import { render } from "./TestTypeSelectionPage.vue?vue&type=template&id=f4bb6f5e&scoped=true"
import script from "./TestTypeSelectionPage.vue?vue&type=script&lang=js"
export * from "./TestTypeSelectionPage.vue?vue&type=script&lang=js"

import "./TestTypeSelectionPage.vue?vue&type=style&index=0&id=f4bb6f5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4bb6f5e"]])

export default __exports__